import React from "react";
import "./WhatsApp.css";

const Whatsapp = () => {
  const phoneNumber = "7042825200";
  const message = "I would like to enquire about your services.";
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <div className="WhatsappContainer">
      <a
        href={whatsappLink}
        className="WhatsappLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa fa-whatsapp" aria-hidden="true"></i>
      </a>
    </div>
  );
};

export default Whatsapp;
